export const PERFIL_MASTERDATA = 2;
export const GRADE_DESCARGA = 1
export const GRADE_CARREGAMENTO = 2
export const FILTERS_DEFAULT = {
  IdUnidadeNegocio: 0,
}